import { EntryViewModel } from "./successEntryModel";
import { FileCategoryModel } from "./uploadDocumentModel";

export class ExportSuccessModel {
  entry?: EntryViewModel;
  exportInitiated = false;
  imageFileCategories: FileCategoryModel[] = [];
  shopConfiguration: { [key: string]: any };
  lineConfiguration: { [key: string]: any };
  aggregatedDownTimeCosts: { [key: string]: any };
}